<template>
  <div class="login-logo">
    <img class="logo" :src="url" :alt="name" v-show="display">
  </div>
</template>

<script>
export default {
  props: {
    url: {
      type: String,
      required: false
    },
    name: {
      type: String,
      required: false
    }
  },
  computed: {
    display () {
      return this.url !== null
    }
  }
}
</script>

<style scoped>
  .logo {
    max-width: 300px;
    max-height: 150px;
  }
</style>
